export { default } from './DetailInfoMerchant';
